import {apiClient} from './apiClient';
import {SelectorItems} from './selectorItems';

export const selectorItemsApi = {
  getItemList: async (endpoint: string): Promise<SelectorItems> => {
    const response = await apiClient.get<SelectorItems>(endpoint);

    if (!Array.isArray(response.data)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return Object.keys(response.data).map((key) => ({name: response.data[key], id: ''}));
    }

    return response.data;
  },
  setItemList: async (endpoint: string, value: string): Promise<SelectorItems> => {
    const response = await apiClient.post<SelectorItems>(endpoint, {name: value});
    return response.data;
  },
  setSelectItemList: async (endpoint: string, values: any): Promise<SelectorItems> => {
    const response = await apiClient.post<SelectorItems>(endpoint, values);
    return response.data;
  },
  editItemList: async (endpoint: string, item: any, value: string): Promise<SelectorItems> => {
    // TODO
    const response = await apiClient.post<SelectorItems>(endpoint, {name: value});
    return response.data;
  },
  deleteItemList: async (endpoint: string, value: string): Promise<SelectorItems> => {
    // TODO
    const response = await apiClient.delete<SelectorItems>(endpoint);
    return response.data;
  },
};
